const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Placeholders the API sends when it has no real value. */
const PLACEHOLDERS = new Set(['unknown', 'untitled', 'n/a', 'null', 'undefined']);

/**
 * Whether a value is safe to show a human as a label. The file-search endpoint
 * returns category as an id, so it reached the UI as
 * "aaaa3335-aaaa-…" — both on the result card and as a filter checkbox, where
 * it was an option nobody could interpret.
 */
export function isDisplayableLabel(value?: string | null): value is string {
  if (!value) return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return !UUID.test(trimmed) && !PLACEHOLDERS.has(trimmed.toLowerCase());
}
